



function jsonToCsv(rows, headers) {
  const escapeCell = (value) => {
    if (value === null || value === undefined) return "";
    const str = String(value);
    // Quote if it contains comma, quote, or newline
    return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
  };

  const lines = new Array(rows.length + 1);
  lines[0] = headers.map(escapeCell).join(",");

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i] ?? {};
    lines[i + 1] = headers.map((h) => escapeCell(row[h])).join(",");
  }

  return lines.join("\r\n");
}

export default jsonToCsv;